import React, { useEffect, useState } from "react";
import { Pagination } from "swiper/modules";
import { IAuthType } from "../../apiservice/authService.type";
import { useAppSelector } from "../../Redux/reduxCustomHook";
import { RootState } from "../../Redux/store";
import "./Home-Comp.css";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import useAuth from "../../hooks/useAuth";
import StreakComponentMini from "../sharedcomponents/streakComponentMini";

export const HomeTopCard = () => {
  const authData: IAuthType = useAppSelector(
    (state: RootState) => state?.AuthData
  );

  const [loadAuth, setLoadAuth] = useState(true);

  const [isVerifying, setIsVerifying] = useState(false);

  const authState = useAuth(loadAuth, () => {
    setLoadAuth(false);
  });

  return (
    <>
      <div className="w-full p-4">
        {/* Slider*/}
        <Swiper
          spaceBetween={20}
          pagination={{ clickable: true }}
          modules={[Pagination]}
          className="w-full"
          breakpoints={{
            768: {
              // Medium screens (md)
              slidesPerView: 1,
              spaceBetween: 20, // Ensure spacing between slides
            },
            1024: {
              // Large screens (lg and above)
              slidesPerView: 1,
              spaceBetween: 20,
            },
          }}
        >
          <SwiperSlide>
            <div className="bg-gradient-to-br from-blue-800 via-indigo-700 to-blue-600 dark:from-blue-700 dark:via-indigo-800 dark:to-blue-900 grid grid-cols-2 text-white rounded-3xl p-5 items-center mb-2 shadow-lg">
              <div className="flex flex-col justify-between h-full">
                {/* text-white is fine for both light and dark on this blue background */}
                <span className="self-start text-[10px] font-semibold uppercase tracking-wider bg-white/20 rounded-full px-2 py-0.5 mb-2">
                  Daily pick
                </span>
                <h3 className="text-xl font-bold leading-tight">Free daily Audio & Book </h3>
                <div className="mt-auto">
                  <p className="mt-2 text-xs text-white/80">
                    All summaries are interpretations and opinions of the
                    narrators. They are not affiliated by the original authors
                    or publishers of the books.
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm"></p>
                <img
                  src={`${
                    process.env.PUBLIC_URL +
                    "/images/homePage/audiobookSample1.svg"
                  }`}
                  alt="Balance"
                  className="w-32 h-32 mt-4"
                />
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>

      {authData?.data?.credentials?.streak ? (
        <div className="w-full p-4">
          <StreakComponentMini
            initialStreak={authData?.data?.credentials?.streak?.noOfDays}
            badgeImage={
              authData?.data?.credentials?.streak?.streakBadge?.imageUrl
            }
            badgeTitle={authData?.data?.credentials?.streak?.streakBadge?.title}
          ></StreakComponentMini>
        </div>
      ) : null}
    </>
  );
};

export default HomeTopCard;
